var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./LoginPopup.jinja');
require('./LoginPopup.less');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .LoginPopup-block.LoginPopup--login .LoginPopup-blockSubmit': 'onLoginClick',
        'input .LoginPopup-block.LoginPopup--login input': 'onLoginInputChange',
        'keydown .LoginPopup-block.LoginPopup--login input': 'onLoginInputKeyDown',
        'click .LoginPopup-block.LoginPopup--login .LoginPopup-blockForgot': 'onOpenForgotClick',

        'click .LoginPopup-block.LoginPopup--forgot .LoginPopup-blockSubmit': 'onForgotClick',
        'input .LoginPopup-block.LoginPopup--forgot input': 'onForgotInputChange',
        'keydown .LoginPopup-block.LoginPopup--forgot input': 'onForgotInputKeyDown',

        'click .LoginPopup-block.LoginPopup--reset .LoginPopup-blockSubmit': 'onResetClick',
        'input .LoginPopup-block.LoginPopup--reset input': 'onResetInputChange',
        'keydown .LoginPopup-block.LoginPopup--reset input': 'onResetInputKeyDown'
    }, BasePopup.prototype.baseEvents),


    forgotApi: function () {
        return Urls['member:api:forgot']('json');
    },


    resetApi: function () {
        return Urls['member:api:reset']('json');
    },



    initialize: function (options) {
        _.bindAll(this, 'onLoginInputChange', 'onForgotInputChange', 'forgotApi');

        this.options = options || {};

        BasePopup.prototype.initialize.call(this, options);
    },


    onPopupShown: function () {

        if (this.options.state == 'login') {
            this.$('.LoginPopup-block.LoginPopup--login input[name="email"]').focus();

            //check auto filled inputs by browser
            setTimeout(this.onLoginInputChange, 0);
            setTimeout(this.onLoginInputChange, 100);
            setTimeout(this.onLoginInputChange, 300);
            setTimeout(this.onLoginInputChange, 500);
            setTimeout(this.onLoginInputChange, 1000);
            setTimeout(this.onLoginInputChange, 2000);
            setTimeout(this.onLoginInputChange, 3000);
        }

        if (this.options.state == 'reset') {
            this.$('.LoginPopup-block.LoginPopup--reset input[name="password"]').focus();
        }

        BasePopup.prototype.onPopupShown.call(this);
    },


    onOpenForgotClick: function () {
        this.$('.LoginPopup-contentWrapper').attr('data-state', 'forgot');
        var $emailLoginInput = this.$('.LoginPopup-block.LoginPopup--login input[name="email"]');
        var $emailForgotInput = this.$('.LoginPopup-block.LoginPopup--forgot input[name="email"]');

        $emailForgotInput.focus();
        $emailForgotInput.val($emailLoginInput.val());

        this.onForgotInputChange();
    },


    onLoginClick: function () {
        var $emailInput = this.$('.LoginPopup-block.LoginPopup--login input[name="email"]');
        var $passwordInput = this.$('.LoginPopup-block.LoginPopup--login input[name="password"]');
        var $button = this.$('.LoginPopup-block.LoginPopup--login .LoginPopup-blockSubmit');

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();

        this._xhr = $.ajax(Urls['member:api:login']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'email': $emailInput.val(),
                'password': $passwordInput.val()
            }),
            'success': function (data) {
                window.location.href = Urls['front:myadg']();
            }.bind(this),
            'error': function (data) {
                console.log(data);
                $button.flashClass('Button--shake', 500);
                $button.removeClass('Button--loading');
            }.bind(this)
        });
    },


    onLoginInputKeyDown: function (e) {
        var $emailInput = this.$('.LoginPopup-block.LoginPopup--login input[name="email"]');
        var $passwordInput = this.$('.LoginPopup-block.LoginPopup--login input[name="password"]');

        if (e.keyCode == 13) {
            if ($(e.currentTarget).is($emailInput)) {
                if ($emailInput.val() && $passwordInput.val()) {
                    this.onLoginClick();
                } else {
                    $passwordInput.focus();
                }
            }

            if ($(e.currentTarget).is($passwordInput)) {
                this.onLoginClick();
            }

            e.preventDefault();
        }
    },


    onLoginInputChange: function (e) {
        var email = this.$('.LoginPopup-block.LoginPopup--login input[name="email"]').val();
        var password = this.$('.LoginPopup-block.LoginPopup--login input[name="password"]').val();
        var isValid = email && password;

        this.$('.LoginPopup-block.LoginPopup--login .LoginPopup-blockSubmit').toggleClass('LoginPopup-blockSubmit--active', !!isValid);
    },






    onForgotClick: function () {
        var email = this.$('.LoginPopup-block.LoginPopup--forgot input[name="email"]').val();
        var $button = this.$('.LoginPopup-block.LoginPopup--forgot .LoginPopup-blockSubmit');
        var isValid = !!email;

        if (!isValid) return;

        $button.addClass('Button--loading');

        $.ajax({
            url: this.forgotApi(),
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                email: email
            }),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                this.$('.LoginPopup-contentWrapper').attr('data-state', 'forgot-sended');

                this.$('.LoginPopup-block.LoginPopup--forgot-sended .LoginPopup-blockThanks span').text(email);
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                }

                console.log('error', arguments);
            },
            context: this
        });

    },


    onForgotInputKeyDown: function (e) {
        var $emailInput = this.$('.LoginPopup-block.LoginPopup--forgot input[name="email"]');

        if (e.keyCode == 13) {
            if ($emailInput.val()) {
                this.onForgotClick();
            }

            e.preventDefault();
        }
    },


    onForgotInputChange: function (e) {
        var email = this.$('.LoginPopup-block.LoginPopup--forgot input[name="email"]').val();

        this.$('.LoginPopup-block.LoginPopup--forgot .LoginPopup-blockSubmit').toggleClass('LoginPopup-blockSubmit--active', !!email);
    },






    onResetClick: function () {
        var password = this.$('.LoginPopup-block.LoginPopup--reset input[name="password"]').val();
        var passwordConfirm = this.$('.LoginPopup-block.LoginPopup--reset input[name="password-confirm"]').val();
        var code = this.$('.LoginPopup-block.LoginPopup--reset input[name="code"]').val();
        var $button = this.$('.LoginPopup-block.LoginPopup--reset .LoginPopup-blockSubmit');
        var isValid = password && passwordConfirm && (password == passwordConfirm);

        if (!isValid) return;

        $button.addClass('Button--loading');

        $.ajax({
            url: this.resetApi(),
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                code: code,
                password: password
            }),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                window.location.href = responseData.next;
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Server error, try again later');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    onResetInputKeyDown: function (e) {
        var $passwordInput = this.$('.LoginPopup-block.LoginPopup--reset input[name="password"]');
        var $passwordConfirmInput = this.$('.LoginPopup-block.LoginPopup--reset input[name="password-confirm"]');

        if (e.keyCode == 13) {
            if ($(e.currentTarget).is($passwordInput)) {
                if ($passwordInput.val() && $passwordConfirmInput.val()) {
                    this.onResetClick();
                } else {
                    $passwordConfirmInput.focus();
                }
            }

            if ($(e.currentTarget).is($passwordConfirmInput)) {
                this.onResetClick();
            }

            e.preventDefault();
        }
    },


    onResetInputChange: function (e) {
        var password = this.$('.LoginPopup-block.LoginPopup--reset input[name="password"]').val();
        var passwordConfirm = this.$('.LoginPopup-block.LoginPopup--reset input[name="password-confirm"]').val();
        var isValid = password && passwordConfirm && (password == passwordConfirm);

        this.$('.LoginPopup-block.LoginPopup--reset .LoginPopup-blockSubmit').toggleClass('LoginPopup-blockSubmit--active', !!isValid);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/LoginPopup/LoginPopup.js
// module id = 274
// module chunks = 0